import { reactive } from 'vue';

/**
 * 首屏/会话引导状态：应用先挂载（显示 App.vue 中的加载层），
 * 路由守卫异步拉取会话与菜单；在权限解析完成（首次导航结束）前只显示加载层。
 * 受保护路由在守卫 next() 之前不会完成导航，因此其内容与菜单不会提前渲染。
 */
export const bootState = reactive({
    loading: true,
});

export function setBootLoading(v: boolean) {
    bootState.loading = v;
}
